<scitis-breadcrumb [breadcrumbRoutes]="routes"></scitis-breadcrumb>

<scitis-app-global-page-header>
  <div class="page-header-title d-flex align-items-center" header-title>
    <scitis-page-header-logo-and-name
      [machineCategory]="pageGlobalParameters.machineCategory"
      [pageName]="pageGlobalParameters.pageName"
      [pageType]="pageGlobalParameters.pageType">
    </scitis-page-header-logo-and-name>
    <div class="page-header-counts">
      <div class="count">
        <span [innerText]="errorCount" class="badge badge-pill badge-primary"></span>
        <span class="count-label" translate>Events</span>
      </div>
    </div>
  </div>

  <ng-template #filterElement>
    <scitis-status-event-group-page-actions (update)="getStatusEventGroupPageData()" (filter)="onFilter($event)" class="page-functions">
    </scitis-status-event-group-page-actions>
  </ng-template>

</scitis-app-global-page-header>

@if (pageGlobalParameters.associatedMenuItem.menuItemParent) {
  <div class="page-content">
    <scitis-status-event-group-page
      [paginateSettings]="paginateSettings"
      [menuItemParent]="pageGlobalParameters.associatedMenuItem.menuItemParent"
      [filtering]="filtering"
      (sort)="onEventSort($event)"
      [statusEvents]="statusEvents">
    </scitis-status-event-group-page>
  </div>
}

<scitis-ngx-pagination [id]="paginateSettings.id"
  [itemsPerPage]="paginateSettings.itemsPerPage"
  [itemsPerPageOptions]="itemsPerPageOptions"
  paginationClass="col"
  (pageNumberChange)="onLoadPageNumber($event)"
(itemsPerPageChange)="onItemsPerPageChange($event)"></scitis-ngx-pagination>
